<template>
    <sys-register-base 
        :loading="loading" 
        :model.sync="modelBase" 
        :title="title" 
        :icon="icon" 
        color="primary white--text"
        v-bind:show.sync="dialog"
        maxWidth="98%"
        :actions="false"
    >

    <template v-slot:tools>

        
    </template>
    
        <template v-slot:form>

            <main-container :showToolBar="false" icon="mdi-account-cash" title="Cartão de Ponto">
                <v-overlay :value="generatingSheets" absolute>
                    <v-progress-circular indeterminate size="64" color="primary" />
                    <p class="mt-4 white--text">{{ generatingMessage }}</p>
                    <p class="text-caption white--text">Aguarde a atualização para continuar.</p>
                </v-overlay>

                <v-alert v-if="collections.length === 0 && !loading && !workTimeId" type="info" outlined dense class="mb-4" icon="mdi-information-outline">
                    Suas folhas de ponto serão exibidas aqui conforme forem geradas. Selecione um período para visualizar.
                </v-alert>
                <v-alert v-else-if="collections.length === 0 && !loading && workTimeId" type="info" outlined dense class="mb-4" icon="mdi-information-outline">
                    Nenhuma folha de ponto encontrada para o período selecionado.
                </v-alert>
                <emc-table-items 
                    :headers="headers" 
                    v-bind:params.sync="params"
                    v-bind:collections.sync="collections"
                    v-bind:meta.sync="meta"
                    v-bind:itemDelete.sync="itemDelete" 
                    v-bind:itemEdit.sync="modelItem"
                    :loading="loading"
                    :find="false"
                    :showDelete="showDeleteButton"
                    :hideEdit="hideEdit"
                >
                    <template v-slot:item.month="{item}">
                        <v-chip x-small color="primary" outlined>{{ item.month }}/{{ item.year }}</v-chip>
                    </template>

                    <template v-slot:item.company="{ item }">

                        <span v-if="item.company">{{ item.company.name }}</span>
                        <small v-if="item.contract"><br/>Matrícula: {{ item.contract.registration }}</small>

                    </template>

                    <template v-slot:item.campuses="{ item }">

                        {{ item.campuses.map(o => o['name']).join(', ') }}

                    </template>

                    <template v-slot:item.shifts="{ item }">

                        {{ item.shifts.map(o => o['name']).join(', ') }}

                    </template>

                    <template v-slot:item.status_sign.name="{ item }">
                        <v-chip
                            v-if="item.status_sign"
                            x-small
                            :color="getStatusColor(item)"
                            outlined
                        >
                            {{ item.status_sign.name }}
                        </v-chip>
                        <span v-else>—</span>
                    </template>

                    <template v-slot:actions="{item}">
                        <emc-table-icon classStyle="mr-6" cancelAutoSmall color="success" icon="mdi-calendar-edit" text-button="Editar" :tool-tip="isBlockedByTerms ? 'Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição' : 'Editar Marcações'" :disabled="isBlockedByTerms" @click="getSheetItems(item)" />
                        <emc-table-icon-download-pdf cancelAutoSmall toolTip="Espelho de Ponto" text-button="Espelho" type="teacher-extract-time-sheet" :item="item" />
                        <emc-table-icon :disabled="item.occurrence_sheet_sign_status_id != 1 || ![2,3,4,5,6].includes(item.month)" classStyle="ml-6" cancelAutoSmall color="purple" icon="mdi-signature-freehand" text-button="Assinar" tool-tip="Assinar Espelho de Ponto" @click="selectedItem = item; showQuestionSign = true" />
                        <emc-table-icon classStyle="ml-2" cancelAutoSmall color="info" icon="mdi-history" text-button="Histórico" tool-tip="Ver Histórico de Assinaturas" @click="openHistoryDialog(item)" />
                    </template>
                    
                </emc-table-items>

                <DialogsConfirmation 
                    :show.sync="showQuestionSign" 
                    message="Confirma o  envio do Espelho de Ponto para Assinatura pela plataforma da B4?" 
                    @confirm="signDocument()"
                    :loading="loadingSign"
                    colorTitle="primary"
                />

                <v-dialog v-model="showCancelDialog" max-width="600" persistent>
                    <v-card>
                        <v-card-title class="error white--text">
                            <v-icon dark class="mr-2">mdi-cancel</v-icon>
                            Cancelar Assinatura
                        </v-card-title>
                        <v-card-text class="pt-4">
                            <v-alert type="warning" dense outlined class="mb-4">
                                Atenção: O cancelamento da assinatura permitirá que o docente assine novamente. 
                                O documento anterior será mantido no histórico para auditoria.
                            </v-alert>
                            <v-textarea
                                v-model="cancelReason"
                                label="Justificativa *"
                                placeholder="Informe o motivo do cancelamento (mínimo 10 caracteres)"
                                :rules="[v => !!v || 'Justificativa obrigatória', v => (v && v.length >= 10) || 'Mínimo 10 caracteres']"
                                outlined
                                counter
                                :maxlength="1000"
                                rows="4"
                            ></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="closeCancelDialog">Voltar</v-btn>
                            <v-btn 
                                color="error" 
                                :loading="loadingCancel" 
                                :disabled="!cancelReason || cancelReason.length < 10"
                                @click="confirmCancelSignature"
                            >
                                Confirmar Cancelamento
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- Dialog de Histórico de Assinaturas -->
                <v-dialog v-model="showHistoryDialog" max-width="800">
                    <v-card>
                        <v-card-title class="info white--text">
                            <v-icon dark class="mr-2">mdi-history</v-icon>
                            Histórico de Assinaturas
                        </v-card-title>
                        <v-card-text class="pt-4">
                            <v-progress-linear v-if="loadingHistory" indeterminate color="primary"></v-progress-linear>
                            <v-alert v-else-if="signatureHistory.length === 0" type="info" dense outlined>
                                Nenhum histórico de assinatura encontrado para esta folha de ponto.
                            </v-alert>
                            <v-timeline v-else dense>
                                <v-timeline-item
                                    v-for="(historyItem, index) in signatureHistory"
                                    :key="index"
                                    :color="getHistoryColor(historyItem.action)"
                                    :icon="getHistoryIcon(historyItem.action)"
                                    small
                                >
                                    <v-card class="elevation-2">
                                        <v-card-title class="text-subtitle-2 py-2">
                                            {{ historyItem.action_label }}
                                            <v-spacer></v-spacer>
                                            <span class="text-caption">{{ historyItem.created_at }}</span>
                                        </v-card-title>
                                        <v-card-text class="py-2">
                                            <div><strong>Responsável:</strong> {{ historyItem.user_name }}</div>
                                            <div><strong>Status:</strong> {{ historyItem.sign_status }}</div>
                                            <div v-if="historyItem.reason">
                                                <strong>Justificativa:</strong> {{ historyItem.reason }}
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-timeline-item>
                            </v-timeline>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="showHistoryDialog = false">Fechar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </main-container>

            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!!message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <emc-modal-form title="Informações" icon="mdi-contacts" v-bind:show.sync="showInfoForm">
                <template v-slot:form>
                    <span v-html="infoForm"></span>
                </template>
            </emc-modal-form>

           <sys-occurrence-sheet-teacher-view-register :model="modelItem" v-bind:show.sync="showFormRegisters" />
           <sys-occurrence-sheet-teacher-item-register @onCompleted="getData()" :model="modelItem" v-bind:show.sync="showFormItems" :isBlockedByTerms="isBlockedByTerms" showAddItem showEditMark />

        </template>

    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceTeacherTimeSheet",
    data: (vm) => ({
        dialog: false,
        collections: [],
        params: {},
        meta: {},
        error: false,
        errors: {},
        modelBase: {},
        showQuestionSign: false,
        modelItem: {},
        showInfoForm: false,
        infoForm: '',
        showFormItems: false,
        loadingSign: false,
        generatingSheets: false,
        generatingMessage: 'Verificando atualização das folhas de ponto...',
        showFormRegisters: false,
        message: '',
        loading: false,
        showDelete: false,
        showForm: false,
        itemDelete: {},
        selectedItem: {},
        deleting: false,
        // Cancelamento de assinatura
        showCancelDialog: false,
        cancelReason: '',
        loadingCancel: false,
        // Histórico de assinaturas
        showHistoryDialog: false,
        signatureHistory: [],
        loadingHistory: false,
        headers: [
            // { text: 'ID', value: 'id'},
            { text: 'Mês', value: 'month'},
            { text: 'Empresa', value: 'company', sortable: false},
            { text: 'Campus', value: 'campuses', sortable: false},
            { text: 'Turno', value: 'shifts', sortable: false},
            { text: 'Período', value: ['date_start','date_end'], type: 'date', range: true},
            { text: 'Status', value: 'status_sign.name'},
            { text: 'Ações', value: 'actions'},
        ]
    }),
    watch: {
        
        itemDelete(item_new, item_old){
            if(item_new !== item_old && Object.keys(item_new).length > 0)
            {
                this.showDelete = true;
            } else {
                this.showDelete = false
            }
        },
        
        params(params_new, params_old){
            if(params_new != params_old) {
                if(!this.loading && this.params.page){
                    this.getData();
                }
            }
        },
        
        dialog(dialog_new, dialog_old) {
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }
        },

        show(show_new, show_old) {
            
            this.dialog = show_new;

            if(show_new){
                this.params = { search: null, column_order: 'id', direction: 'asc', page: 1, per_page: 5 };
                this.collections = [];
            }
        },

        modelItem(item_new, item_old){
          
        if(item_new !== item_old && this.modelItem.id)
          {
              this.showForm = true;
              this.errors = {};
          } else if(Object.keys(this.model).length === 0){
              this.showForm = false;
              this.errors = {};
          }           
      },

      showForm(show_new, show_old) {
          if(show_new != show_old && !show_new) {
              this.modelItem = {};
          }
      },
        
    },
    props: {
        model: {
            default: null
        },
        icon: {
            type: String,
            default: "mdi-account-cash"
        },
        title: {
            type: String,
            default: "Folhas de Ponto"
        },
        show: {
            type: Boolean,
            default: false
        },
        teacherId: {
            type: Number,
            required: true
        },
        workTimeId: {
            type: Number,
            required: true
        },
        showDeleteButton: {
            type: Boolean,
            default: true
        },
        hideEdit: {
            type: Boolean,
            default: false
        },
        isBlockedByTerms: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('timeSheet', [
            'ActionIndexOccurrenceSheets',
            'ActionOccurrenceSheetSign',
            'ActionCancelSignatureOccurrenceSheet',
            'ActionSignatureHistoryOccurrenceSheet',
            'ActionOnDemandTimeSheetStatus',
            'ActionOnDemandTimeSheetGenerate'
        ]),
        ...mapActions('controlPanel', ['ActionExportPdf']),

        async ensureOnDemandGeneration() {
            if (!this.teacherId || !this.workTimeId) {
                return;
            }

            this.generatingSheets = true;
            this.generatingMessage = 'Verificando atualização das folhas de ponto...';

            try {
                const statusResponse = await this.ActionOnDemandTimeSheetStatus({
                    teacher_id: this.teacherId,
                    work_time_id: this.workTimeId
                });

                const statusData = statusResponse.data || {};

                if (!statusData.enabled || !statusData.needs_update) {
                    return;
                }

                this.generatingMessage = 'Atualizando suas folhas de ponto...';

                await this.ActionOnDemandTimeSheetGenerate({
                    teacher_id: this.teacherId,
                    work_time_id: this.workTimeId
                });
            } catch (error) {
                this.message = error.message || 'Erro ao atualizar folhas de ponto por demanda';
                this.error = true;
            } finally {
                this.generatingSheets = false;
            }
        },

        async getData(){
            
            this.error = false;
            this.message = '';
            this.params;
            this.loading = true;
            this.showInfoForm = false;
            this.infoForm = '';

            await this.ensureOnDemandGeneration();

            this.params.column_order = 'month';
            this.params.direction = 'desc';

            let payload = {
                ...this.params,
                with: 'campuses|teacher|shifts|status|types|company|contract:id,registration|institution.occurrenceSetting|statusSign',
                find_columns: {
                    teacher_id: this.teacherId,
                    work_time_id: this.workTimeId,
                },
                columns: 'info_date'
            };

            this.ActionIndexOccurrenceSheets(payload)
                .then((res) => {
                    
                    this.collections = res.data;
                    this.meta = res.meta;

                    if(this.collections.length > 0){
                        
                        let setting = this.collections[0].institution.occurrence_setting;

                        if(setting && setting.text_form_mark_sheets){
                            this.infoForm = setting.text_form_mark_sheets;
                            this.showInfoForm = true;
                        }

                    }

                })
                .finally(() => {
                    this.loading = false;
                });
        },

        signDocument(){

            this.message = '';
            this.error = false;
            this.errors = [];
            this.loadingSign = true;
            
            this.ActionOccurrenceSheetSign({ id: this.selectedItem.id})
                .then((res) => {
                    this.showQuestionSign = false;
                    this.getData();
                })
                .catch((error) =>{
                
                    this.message    = error.message;
                    this.error      = true;
                    this.errors     = error.errors;

                })
                .finally(() => {
                    this.loadingSign = false;
                });


            

        },  

        openRegisters(){
            
            this.modelItem = item;
            this.showFormRegisters = true;

        },  

        getSheetItems(item){
            this.modelItem = item;
            this.showFormItems = true;
        },

        async exportPdf(item){
            
            var payload = {
                id: item.id,
                type: 'teacher-extract-time-sheet'
            };

            this.ActionExportPdf(payload)
                 .then(res => {
                    
                    //const uint8arr = new Uint8Array(await new Response(res.body).arrayBuffer());

                    var blob = new Blob([res.body], {
                        type: 'application/pdf'
                    });

                    var fileUrl = (window.URL || window.webkitURL).createObjectURL(blob);

                    window.open(fileUrl, '_blank');

                    // if (res.responseType === 'application/pdf') {
                    //     window.open(fileUrl);
                    // } else {
                    //     var a = document.createElement("a");
                    //     document.body.appendChild(a);
                    //     a.style = "display: none"
                    //     a.href = fileUrl;
                    //     a.download = 'arquivo.pdf';
                    //     a.target = "_blank";
                    //     a.click();
                    //     window.URL.revokeObjectURL(fileUrl);
                    // }
                    
                    // let blob = new Blob([res.data], { type: 'application/pdf' });
                    // const url = URL.createObjectURL(blob);
                    // window.open(url, '_blank');
                    // const a = document.createElement('a');
                    // a.style.display = 'none';
                    // a.href = url;
                    // a.download = 'arquivo.pdf';
                    // document.body.appendChild(a);
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                 });

            return;

            this.ActionExportPdf(payload)
                .then((res) => {
                    
                    res.blob().then(blob => {
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = none;
                        a.href = url;
                        a.download = 'arquivo.pdf';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    });
                    
                    // create element <a> for download PDF
                    // const link = document.createElement('a');
                    // link.href = res.body;
                    // link.target = '_blank';
                    // // link.download = this.pdfFileName;

                    // // Simulate a click on the element <a>
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);

                    // const url = window.URL.createObjectURL(new Blob([res.data]));
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', 'teste.pdf');
                    // document.body.appendChild(link);
                    // link.click();


                    // window.open("data:application/pdf," + encodeURI(res.data));
                    // window.open("data:application/pdf," + window.URL.createObjectURL(new Blob([res.data])));
                    // window.open("data:application/pdf," + escape(res.data));
                    // window.open("data:application/octet-stream;charset=utf-16le;base64,"+ res.data);

                    // const file2 = new Blob([res.data], { type: 'application/pdf' });
                    // const url2 = URL.createObjectURL(file2);
                    // window.open(url2, '_blank');

                    // window.open("data:application/pdf," + encodeURI(res.data));
                    // window.open("data:application/pdf," + encodeURI(res.data));

                })
                .finally(() => {
                    
                });
        },

        // Métodos para Cancelamento de Assinatura
        openCancelDialog(item) {
            this.selectedItem = item;
            this.cancelReason = '';
            this.showCancelDialog = true;
        },

        closeCancelDialog() {
            this.showCancelDialog = false;
            this.cancelReason = '';
            this.selectedItem = {};
        },

        confirmCancelSignature() {
            if (!this.cancelReason || this.cancelReason.length < 10) {
                this.message = 'A justificativa deve ter no mínimo 10 caracteres';
                this.error = true;
                return;
            }

            this.message = '';
            this.error = false;
            this.loadingCancel = true;

            this.ActionCancelSignatureOccurrenceSheet({
                id: this.selectedItem.id,
                reason: this.cancelReason
            })
                .then((res) => {
                    this.message = 'Assinatura cancelada com sucesso!';
                    this.error = false;
                    this.closeCancelDialog();
                    this.getData();
                })
                .catch((error) => {
                    this.message = error.message || 'Erro ao cancelar assinatura';
                    this.error = true;
                    this.errors = error.errors || {};
                })
                .finally(() => {
                    this.loadingCancel = false;
                });
        },

        // Métodos para Histórico de Assinaturas
        openHistoryDialog(item) {
            this.selectedItem = item;
            this.signatureHistory = [];
            this.showHistoryDialog = true;
            this.loadSignatureHistory();
        },

        loadSignatureHistory() {
            this.loadingHistory = true;

            this.ActionSignatureHistoryOccurrenceSheet({
                id: this.selectedItem.id
            })
                .then((res) => {
                    this.signatureHistory = res.data || [];
                })
                .catch((error) => {
                    this.message = error.message || 'Erro ao carregar histórico';
                    this.error = true;
                })
                .finally(() => {
                    this.loadingHistory = false;
                });
        },

        getHistoryColor(action) {
            const colors = {
                'sent': 'purple',
                'cancelled': 'error',
                'signed': 'success'
            };
            return colors[action] || 'grey';
        },

        getHistoryIcon(action) {
            const icons = {
                'sent': 'mdi-send',
                'cancelled': 'mdi-cancel',
                'signed': 'mdi-check-circle'
            };
            return icons[action] || 'mdi-information';
        },

        getStatusColor(item) {
            const statusId = item.occurrence_sheet_sign_status_id;
            if (statusId === 2) return 'success';
            if (statusId === 3) return 'purple';
            return 'grey';
        }
    
    }
}
</script>